import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import { entregaService } from '../services/api';

const METODOS = ['Efectivo', 'Tarjeta', 'Deposito', 'SINPE', 'Transferencia', 'Tasa Cero', 'Minicuotas'];
const fmt = n => '₡' + Number(n || 0).toLocaleString('es-CR');
const fmtFecha = f => { if (!f) return '—'; const d = f.split('T')[0].split('-'); return `${parseInt(d[2])}-${parseInt(d[1])}-${d[0]}`; };

function ModalEntregar({ entrega, onClose, onDone }) {
  const totalOrden = Number(entrega.amount) + Number(entrega.shipping || 0);
  const abonado = Number(entrega.abonado || 0);
  const saldo = entrega.saldo !== undefined ? Number(entrega.saldo) : totalOrden;
  const [pagos, setPagos] = useState([{ metodo: 'Efectivo', monto: saldo }]);
  const [notas, setNotas] = useState('');
  const [loading, setLoading] = useState(false);

  const totalPagos = pagos.reduce((s, p) => s + Number(p.monto || 0), 0);

  const setPago = (i, campo, val) => setPagos(prev => prev.map((p, idx) => idx === i ? { ...p, [campo]: val } : p));
  const addPago = () => setPagos(prev => [...prev, { metodo: 'Efectivo', monto: 0 }]);
  const delPago = (i) => setPagos(prev => prev.filter((_, idx) => idx !== i));

  const guardar = async () => {
    if (totalPagos <= 0) { alert('Debe registrar al menos un pago'); return; }
    setLoading(true);
    try {
      await entregaService.entregar(entrega.id, pagos.map(p => ({ metodo: p.metodo, monto: Number(p.monto) })), notas);
      alert('✅ Entrega registrada');
      onDone();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al registrar');
    }
    setLoading(false);
  };

  const guardarYaCancelado = async () => {
    if (!window.confirm('¿Confirmar que esta orden YA venía cancelada (pagada antes)? No se registrará ningún cobro.')) return;
    setLoading(true);
    try {
      await entregaService.entregar(entrega.id, [{ metodo: 'Ya cancelado', monto: 0 }], notas);
      alert('✅ Entrega registrada (ya cancelada)');
      onDone();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al registrar');
    }
    setLoading(false);
  };

  return (
    <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:300, padding:12 }}>
      <div onClick={e=>e.stopPropagation()} style={{ background:'#fff', borderRadius:14, padding:22, maxWidth:480, width:'100%', maxHeight:'92vh', overflowY:'auto' }}>
        <div style={{ fontWeight:800, fontSize:18, color:'#5c3d2e', marginBottom:4 }}>Registrar entrega</div>
        <div style={{ fontSize:13, color:'#888', marginBottom:14 }}>{entrega.numero} — {entrega.cliente_nombre}</div>

        <div style={{ background:'#f8f5f0', borderRadius:10, padding:14, marginBottom:16, textAlign:'center' }}>
          <div style={{ fontSize:12, color:'#888' }}>Total a cobrar</div>
          <div style={{ fontSize:26, fontWeight:800, color:'#5c3d2e' }}>{fmt(saldo)}</div>
          {abonado > 0 && <div style={{ fontSize:12, color:'#888', marginTop:2 }}>Total: {fmt(totalOrden)} · Abonado: {fmt(abonado)}</div>}
        </div>

        <div style={{ fontSize:13, fontWeight:700, color:'#5c3d2e', marginBottom:8 }}>Forma(s) de pago</div>
        {pagos.map((p, i) => (
          <div key={i} style={{ display:'flex', gap:8, marginBottom:8, alignItems:'center' }}>
            <select value={p.metodo} onChange={e=>setPago(i,'metodo',e.target.value)}
              style={{ flex:1, padding:'10px', border:'1px solid #ddd', borderRadius:8, fontSize:14 }}>
              {METODOS.map(m => <option key={m}>{m}</option>)}
            </select>
            <input type="number" value={p.monto} onChange={e=>setPago(i,'monto',e.target.value)}
              style={{ width:120, padding:'10px', border:'1px solid #ddd', borderRadius:8, fontSize:14 }} />
            {pagos.length > 1 && (
              <button onClick={()=>delPago(i)} style={{ background:'#fee', color:'#c00', border:'none', borderRadius:8, width:38, height:38, fontSize:16, cursor:'pointer' }}>✕</button>
            )}
          </div>
        ))}
        <button onClick={addPago} style={{ background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'8px 14px', borderRadius:8, fontSize:13, fontWeight:600, cursor:'pointer', marginBottom:14 }}>
          + Agregar otra forma de pago
        </button>

        <div style={{ display:'flex', justifyContent:'space-between', padding:'10px 0', borderTop:'2px solid #eee', marginBottom:14, fontSize:15, fontWeight:700 }}>
          <span>Total pagos:</span>
          <span style={{ color: totalPagos === saldo ? '#10b981' : '#f59e0b' }}>{fmt(totalPagos)}</span>
        </div>

        <textarea value={notas} onChange={e=>setNotas(e.target.value)} placeholder="Notas (opcional)..."
          style={{ width:'100%', padding:'10px', border:'1px solid #ddd', borderRadius:8, fontSize:14, boxSizing:'border-box', minHeight:60, marginBottom:14, resize:'vertical' }} />

        <button onClick={guardarYaCancelado} disabled={loading}
          style={{ width:'100%', background:'#fff', color:'#5c3d2e', border:'2px solid #5c3d2e', padding:'12px', borderRadius:10, fontSize:14, fontWeight:700, cursor:'pointer', marginBottom:10, opacity:loading?0.7:1 }}>
          📋 Ya venía cancelada (no cobrar)
        </button>

        <div style={{ display:'flex', gap:8 }}>
          <button onClick={guardar} disabled={loading}
            style={{ flex:1, background:'#10b981', color:'#fff', border:'none', padding:'14px', borderRadius:10, fontSize:15, fontWeight:700, cursor:'pointer', opacity:loading?0.7:1 }}>
            {loading ? 'Guardando...' : '✅ Confirmar entrega'}
          </button>
          <button onClick={onClose} style={{ background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'14px 18px', borderRadius:10, fontSize:14, cursor:'pointer' }}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

function ModalNoEntregar({ entrega, onClose, onDone }) {
  const [motivo, setMotivo] = useState('');
  const [loading, setLoading] = useState(false);
  const guardar = async () => {
    if (!motivo.trim()) { alert('Indique el motivo'); return; }
    setLoading(true);
    try {
      await entregaService.noEntregar(entrega.id, motivo);
      alert('Registrado como no entregada');
      onDone();
    } catch (err) { alert(err.response?.data?.error || 'Error'); }
    setLoading(false);
  };
  return (
    <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:300, padding:12 }}>
      <div onClick={e=>e.stopPropagation()} style={{ background:'#fff', borderRadius:14, padding:22, maxWidth:420, width:'100%' }}>
        <div style={{ fontWeight:800, fontSize:17, color:'#5c3d2e', marginBottom:4 }}>No se pudo entregar</div>
        <div style={{ fontSize:13, color:'#888', marginBottom:14 }}>{entrega.numero} — {entrega.cliente_nombre}</div>
        <textarea value={motivo} onChange={e=>setMotivo(e.target.value)} placeholder="¿Por qué no se pudo entregar? (cliente ausente, dirección incorrecta, etc.)"
          style={{ width:'100%', padding:'10px', border:'1px solid #ddd', borderRadius:8, fontSize:14, boxSizing:'border-box', minHeight:80, marginBottom:14, resize:'vertical' }} />
        <div style={{ display:'flex', gap:8 }}>
          <button onClick={guardar} disabled={loading} style={{ flex:1, background:'#ef4444', color:'#fff', border:'none', padding:'12px', borderRadius:10, fontSize:14, fontWeight:700, cursor:'pointer', opacity:loading?0.7:1 }}>
            {loading ? 'Guardando...' : 'Confirmar'}
          </button>
          <button onClick={onClose} style={{ background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'12px 18px', borderRadius:10, fontSize:14, cursor:'pointer' }}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

function ModalEditarPago({ entrega, onClose, onDone }) {
  const iniciales = (entrega.pagos_actuales && entrega.pagos_actuales.length > 0)
    ? entrega.pagos_actuales.map(p => ({ metodo: p.metodo, monto: Number(p.monto) }))
    : [{ metodo: "Efectivo", monto: 0 }];
  const [pagos, setPagos] = useState(iniciales);
  const [loading, setLoading] = useState(false);
  const totalPagos = pagos.reduce((s, p) => s + Number(p.monto || 0), 0);
  const setPago = (i, campo, val) => setPagos(prev => prev.map((p, idx) => idx === i ? { ...p, [campo]: val } : p));
  const addPago = () => setPagos(prev => [...prev, { metodo: "Efectivo", monto: 0 }]);
  const delPago = (i) => setPagos(prev => prev.filter((_, idx) => idx !== i));
  const guardar = async () => {
    if (totalPagos <= 0) { alert("Debe registrar al menos un pago"); return; }
    setLoading(true);
    try {
      await entregaService.editarPagos(entrega.id, pagos.map(p => ({ metodo: p.metodo, monto: Number(p.monto) })));
      alert("Pago actualizado");
      onDone();
    } catch {
      alert("Error al actualizar el pago");
      setLoading(false);
    }
  };
  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000, padding:16 }} onClick={onClose}>
      <div style={{ background:"#fff", borderRadius:16, padding:20, width:400, maxWidth:"100%", maxHeight:"90vh", overflowY:"auto" }} onClick={e=>e.stopPropagation()}>
        <h2 style={{ color:"#5c3d2e", fontSize:18, marginTop:0 }}>Editar pago — {entrega.numero}</h2>
        <div style={{ fontSize:13, fontWeight:700, color:"#5c3d2e", marginBottom:8 }}>Forma(s) de pago</div>
        {pagos.map((p, i) => (
          <div key={i} style={{ display:"flex", gap:6, marginBottom:8 }}>
            <select value={p.metodo} onChange={e=>setPago(i,"metodo",e.target.value)} style={{ flex:1, padding:10, borderRadius:8, border:"1px solid #ddd", fontSize:14 }}>
              {METODOS.map(m => <option key={m}>{m}</option>)}
            </select>
            <input type="number" value={p.monto} onChange={e=>setPago(i,"monto",e.target.value)} style={{ width:110, padding:10, borderRadius:8, border:"1px solid #ddd", fontSize:14 }} />
            {pagos.length > 1 && <button onClick={()=>delPago(i)} style={{ background:"#fee", color:"#ef4444", border:"none", borderRadius:8, padding:"0 12px", cursor:"pointer" }}>✕</button>}
          </div>
        ))}
        <button onClick={addPago} style={{ background:"none", color:"#a0522d", border:"none", fontSize:13, cursor:"pointer", marginBottom:10 }}>+ Agregar otra forma de pago</button>
        <div style={{ display:"flex", justifyContent:"space-between", fontWeight:700, color:"#5c3d2e", marginBottom:14 }}>
          <span>Total:</span><span>{fmt(totalPagos)}</span>
        </div>
        <div style={{ display:"flex", gap:8 }}>
          <button onClick={guardar} disabled={loading} style={{ flex:1, background:"#10b981", color:"#fff", border:"none", padding:12, borderRadius:10, fontWeight:700, cursor:"pointer" }}>{loading ? "Guardando..." : "Guardar cambios"}</button>
          <button onClick={onClose} style={{ background:"#f0ebe5", color:"#5c3d2e", border:"none", padding:"12px 16px", borderRadius:10, fontWeight:600, cursor:"pointer" }}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default function MisEntregas() {
  const { user } = useAuth();
  const [entregas, setEntregas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [entregar, setEntregar] = useState(null);
  const [noEntregar, setNoEntregar] = useState(null);
  const [editarPago, setEditarPago] = useState(null);

  const cargar = async () => {
    try {
      const res = await entregaService.misEntregas();
      setEntregas(res.data);
    } catch {}
    setLoading(false);
  };

  useEffect(() => {
    cargar();
    const intervalo = setInterval(cargar, 30000); // refrescar cada 30s
    return () => clearInterval(intervalo);
  }, []);

  const onDone = () => { setEntregar(null); setNoEntregar(null); setEditarPago(null); cargar(); };

  return (
    <div style={{ fontFamily:"'Segoe UI',sans-serif", minHeight:'100vh', background:'#f8f5f0' }}>
      <Navbar />
      <div style={{ maxWidth:680, margin:'0 auto', padding:'16px 12px' }}>
        <h1 style={{ color:'#5c3d2e', fontSize:22, marginBottom:4 }}>🚚 Mis Entregas</h1>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
          <span style={{ fontSize:13, color:'#888' }}>{entregas.length} entrega{entregas.length!==1?'s':''} pendiente{entregas.length!==1?'s':''}</span>
          <button onClick={cargar} style={{ background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'8px 14px', borderRadius:8, fontSize:13, fontWeight:600, cursor:'pointer' }}>🔄 Actualizar</button>
        </div>

        {loading && <div style={{ textAlign:'center', padding:40, color:'#aaa' }}>Cargando...</div>}
        {!loading && entregas.length === 0 && (
          <div style={{ textAlign:'center', padding:40, color:'#aaa', background:'#fff', borderRadius:12 }}>
            No tiene entregas asignadas
          </div>
        )}

        {entregas.filter(e => e.estado !== 'Entregada').length === 0 && entregas.length > 0 && <div style={{ textAlign:'center', color:'#888', padding:12 }}>No tenés entregas pendientes.</div>}
        {entregas.map((e, idx) => {
          const total = e.saldo !== undefined ? Number(e.saldo) : (Number(e.amount) + Number(e.shipping || 0));
          const esPrimeraPendiente = e.estado !== 'Entregada' && idx === entregas.findIndex(x => x.estado !== 'Entregada');
          const esPrimeraEntregada = e.estado === 'Entregada' && idx === entregas.findIndex(x => x.estado === 'Entregada');
          return (
            <div key={'g'+e.id}>
            {esPrimeraPendiente && <div style={{ fontWeight:800, fontSize:15, color:'#5c3d2e', margin:'4px 0 10px' }}>📦 Pendientes de entregar</div>}
            {esPrimeraEntregada && <div style={{ fontWeight:800, fontSize:15, color:'#1e7e34', margin:'18px 0 10px', borderTop:'1px solid #e0d0c0', paddingTop:14 }}>✅ Entregadas hoy (podés editar el pago)</div>}
            <div key={e.id} style={{ background:'#fff', borderRadius:12, padding:16, marginBottom:14, boxShadow:'0 1px 6px rgba(0,0,0,0.08)' }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:8 }}>
                <div>
                  <div style={{ fontWeight:800, fontSize:16, color:'#a0522d' }}>{e.numero}</div>
                  <div style={{ fontWeight:700, fontSize:15 }}>{e.cliente_nombre}</div>
                </div>
                <div style={{ textAlign:'right' }}>
                  <div style={{ fontSize:11, color:'#888' }}>A cobrar</div>
                  <div style={{ fontWeight:800, fontSize:18, color:'#5c3d2e' }}>{fmt(total)}</div>
                </div>
              </div>

              <div style={{ fontSize:14, color:'#444', marginBottom:6 }}>📦 {e.article}</div>
              {e.address && <div style={{ fontSize:14, color:'#444', marginBottom:4 }}>📍 {e.address}</div>}
              {e.phone1 && <div style={{ fontSize:14, color:'#444', marginBottom:4 }}>📞 <a href={`tel:${e.phone1}`} style={{ color:'#3b82f6' }}>{e.phone1}</a></div>}
              {e.cedula && <div style={{ fontSize:13, color:'#888', marginBottom:4 }}>Cédula: {e.cedula}</div>}
              <div style={{ fontSize:13, color:'#888', marginBottom:6 }}>Entrega: {fmtFecha(e.delivery_date)}</div>

              {e.items && e.items.length > 0 && (
                <div style={{ background:'#f8f5f0', borderRadius:8, padding:10, marginBottom:10, fontSize:13 }}>
                  <div style={{ fontWeight:700, color:'#5c3d2e', marginBottom:4 }}>Detalle:</div>
                  {e.items.map(it => (
                    <div key={it.id} style={{ display:'flex', justifyContent:'space-between', padding:'2px 0' }}>
                      <span>{it.cantidad}× {it.articulo}</span>
                      <span>{fmt(it.cantidad * it.precio_unitario)}</span>
                    </div>
                  ))}
                  {e.shipping > 0 && <div style={{ display:'flex', justifyContent:'space-between', padding:'2px 0', color:'#888' }}><span>Envío</span><span>{fmt(e.shipping)}</span></div>}
                </div>
              )}

              {e.observations && (
                <div style={{ background:'#fff8f0', border:'1px solid #f0d9c0', borderRadius:8, padding:10, marginBottom:10, fontSize:13 }}>
                  📝 {e.observations}
                </div>
              )}

              {e.estado === 'Entregada' ? (
                <div>
                  <div style={{ background:'#e8f7ec', borderRadius:8, padding:10, marginBottom:10, fontSize:13, color:'#1e7e34', fontWeight:700 }}>
                    ✅ Entregada hoy{e.pagos_actuales && e.pagos_actuales.length > 0 ? ' · ' + e.pagos_actuales.map(p => p.metodo + ' ' + fmt(p.monto)).join(', ') : ''}
                  </div>
                  <button onClick={()=>setEditarPago(e)} style={{ width:'100%', background:'#f59e0b', color:'#fff', border:'none', padding:'12px', borderRadius:10, fontSize:14, fontWeight:700, cursor:'pointer' }}>
                    ✏️ Editar pago
                  </button>
                </div>
              ) : (
                <div style={{ display:'flex', gap:8 }}>
                  <button onClick={()=>setEntregar(e)} style={{ flex:1, background:'#10b981', color:'#fff', border:'none', padding:'12px', borderRadius:10, fontSize:14, fontWeight:700, cursor:'pointer' }}>
                    ✅ Entregar
                  </button>
                  <button onClick={()=>setNoEntregar(e)} style={{ background:'#f0ebe5', color:'#ef4444', border:'none', padding:'12px 16px', borderRadius:10, fontSize:14, fontWeight:600, cursor:'pointer' }}>
                    ❌ No se pudo
                  </button>
                </div>
              )}
            </div>
            </div>
          );
        })}
      </div>

      {entregar && <ModalEntregar entrega={entregar} onClose={()=>setEntregar(null)} onDone={onDone} />}
      {noEntregar && <ModalNoEntregar entrega={noEntregar} onClose={()=>setNoEntregar(null)} onDone={onDone} />}
      {editarPago && <ModalEditarPago entrega={editarPago} onClose={()=>setEditarPago(null)} onDone={onDone} />}
    </div>
  );
}
